export default __webpack_public_path__ + "static/media/9.a36ae5b3.svg";